import { gsap } from 'gsap';
import gsapCore from 'gsap/gsap-core';
import Scrolltrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(Scrolltrigger);
gsap.config({ nullTargetWarn: false, });

$('.p-newgraduate-top').find('.main-catch').addClass('imgZoomDownMv');
const alertmsg = function () {
  $('.p-newgraduate-top').find('.bg').addClass('is-view');
}
const alertmsg2 = function () {
  $('.p-newgraduate-top').find('.bg2').addClass('is-view');
}

setTimeout(alertmsg, 500);
setTimeout(alertmsg2, 3000);


gsap.utils.toArray(".mv-view").forEach(target => {
  gsap.fromTo(target,
    {
      autoAlpha: 0, // 要素を隠す
      y: 20 // 縦方向に+20px
    },
    {
      autoAlpha: 1, // 要素を表示
      duration: 1, // 1秒かけてアニメーション
      y: 0, // 縦方向0に
      scrollTrigger: { // scrollTriggerの設定
        trigger: target, // ターゲットとなる要素を指定
        start: 'center 75%',
        end: 'center 75%',// アニメーションの開始位置を設定。
        //markers: true,
      }
    });
});
